// src/lib/v2Properties.ts
import type { V2Property } from '@/types/analyticsV2';

/**
 * The v2 properties a screen can show something for: those with check-in
 * data. A property without the flag (an older response) counts as having none,
 * so a v2 screen is never offered on a guess.
 */
export const withCheckinData = (properties: readonly V2Property[]): V2Property[] =>
  properties.filter((p) => p.hasCheckinData === true);

/**
 * The properties «Satisfacción» can show: those with check-in data or with
 * satisfaction-survey answers (a hotel may send surveys before anything else).
 */
export const withCheckinOrSurveyData = (properties: readonly V2Property[]): V2Property[] =>
  properties.filter((p) => p.hasCheckinData === true || p.hasSurveyData === true);

/**
 * Whether a v2 screen is offered in the navigation. «Satisfacción» follows its
 * own selector (check-in data or survey answers); every other v2 screen needs
 * a property with check-in data.
 */
export const isV2ScreenOffered = (
  name: string,
  hasCheckinProperty: boolean,
  hasSurveyProperty: boolean,
): boolean => (name === 'satisfaction' ? hasCheckinProperty || hasSurveyProperty : hasCheckinProperty);
